export const components = {
  "24331-1": ["2093-3", "2571-8", "2085-9", "13457-7", "13458-5"],
  "24325-3": ["2885-2", "1751-7", "1975-2", "1968-7", "6768-6", "1920-8", "1742-6"] 
};
